export default {
  // 审批前台信息
  approval: {
    launched: '我发起的',
    waitme: '待我审批',
    haveApproval: '我已审批',
    ccme: '抄送给我',
    theme: '主题',
    applytime: '申请时间',
    closingTime: '审结时间',
    currentApproverUser: '当前审批人',
    version: '版本',
    type: '类型',
    status: '审批状态',
    addApproval: '新增审批',
    nextApprover: '下一环节审批人',
    chooseMember: '选择成员',
    chooseDepartment: '选择部门',
    dynamicParameter: '动态参数',
    pendingApproval: '待审批',
    approvaling: '审批中',
    approvalPast: '审批通过',
    papprovalReject: '审批驳回',
    rescinded: '已撤销',
    toBeInitiated: '待发起',
    toBeSubmit: '待提交',
    transTo: '已转交',
    admin: '管理员',
    nodeApproverFrom: '将节点审批人从',
    modifiedTo: '修改为',
    alreadyWaited: '已等待',
    pleaseSignHere: '请在此手写签名',
    handSignature: '手写签名',
    inner: '内',
    duplicateData: '存在重复的数据',
    pleaseCheck: '请检查',
    pass: '通过',
    reject: '驳回',
    passOn: '转交',
    CC: '抄送',
    urge: '催办',
    revoke: '撤销',
    originalResume: '原始简历',
    unknown: '未知',
    approvalProcess: '审批流程',
    copyPerson: '抄送人',
    ruleCondition: '规则条件',
    passAndEnd: '通过且结束',
    passAndTransfer: '通过并转审',
    needAppointNextApprlval: '需要指定下一审批人',
    signature: '签名',
    clickSignature: '点击签名',
    rejectionMode: '驳回方式',
    rejectedNode: '驳回节点',
    approvalOpinion2001: '请输入驳回意见（200字以内，非必填）',
    approvalOpinion200: '请输入审批意见（200字以内，非必填）',
    approvalOpinion501: '请输入提醒内容（50字以内）',
    approvalOpinion502: '请输入转交理由（50字以内，非必填）',
    urgeReason: '催办原因',
    approvalOpinion: '审批意见',
    passOnReason: '转交理由',
    cexiaohou01: '撤销后，该审批将从审批人、抄送人处撤回，审批流程将会直接终止',
    determineRevoke: '你确定要撤销吗?',
    Approver: '审批人',
    nextStep: '下一环节',
    passFreeFlow: '通过-自由流程',
    approverNotEmpty: '审批人不能为空',
    approvalSuccess: '审批成功',
    passOnSuccess: '转交成功',
    urgeSuccess: '催办成功',
    revokeSuccess: '撤销成功',
    CCSuccess: '抄送成功',
    rejectSuccess: '驳回成功',
    urgeNotEmpty: '催办原因不能为空',
    copyPersonNotEmpty: '抄送人不能为空',
    rejectNodeNotEmpty: '驳回节点不能为空',
    chooseApprovalType: '选择审批类型',

    // 2020-11-16增加新的国际化字段
    dismissApproval: '免审-系统自动审批通过',
    intelligentRobot: '智能机器人',
    rejectionContent: '驳回原因'
  }
}
